import { render, staticRenderFns } from "./reclaim-bucket.vue?vue&type=template&id=555e1b83&scoped=true"
import script from "./reclaim-bucket.vue?vue&type=script&lang=js"
export * from "./reclaim-bucket.vue?vue&type=script&lang=js"
import style0 from "./reclaim-bucket.vue?vue&type=style&index=0&id=555e1b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555e1b83",
  null
  
)

export default component.exports